import React from 'react';
const TermsConditions = () => {
  return <div className="min-h-screen bg-white" data-id="element-567">
      <div className="bg-mwc-burgundy text-white py-12" data-id="element-568">
        <div className="container mx-auto px-4" data-id="element-569">
          <h1 className="text-3xl font-bold text-center mb-4" data-id="element-570">
            Terms & Conditions
          </h1>
          <p className="text-lg text-center max-w-3xl mx-auto" data-id="element-571">
            The terms governing your use of our appliance repair and maintenance
            services
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 py-12" data-id="element-572">
        <div className="max-w-3xl mx-auto" data-id="element-573">
          <div className="bg-white rounded-lg shadow-md p-8" data-id="element-574">
            <div className="mb-8" data-id="element-575">
              <p className="text-gray-700" data-id="element-576">
                These Terms and Conditions govern your use of repair and
                maintenance services provided by Maplewood-Care. By purchasing
                our prepaid service packages or booking individual repair
                services, you agree to be bound by these terms.
              </p>
            </div>
            <div className="mb-8" data-id="element-577">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-578">
                Prepaid Service Packages
              </h2>
              <div className="bg-mwc-lightpink p-4 rounded-lg mb-4" data-id="element-579">
                <p className="text-gray-700 mb-2" data-id="element-580">
                  Our prepaid service packages provide access to repair and
                  maintenance services for specified household appliances,
                  subject to the following conditions:
                </p>
                <ul className="list-disc pl-6 text-gray-700" data-id="element-581">
                  <li data-id="element-582">
                    Service access begins immediately upon payment confirmation
                  </li>
                  <li data-id="element-583">
                    Appliances must be in working order at the time of package
                    purchase (pre-existing faults are excluded)
                  </li>
                  <li data-id="element-584">
                    Appliances must be used for domestic purposes only, not
                    commercial use
                  </li>
                  <li data-id="element-585">
                    Appliances must be located within mainland UK (excluding
                    certain remote areas)
                  </li>
                  <li data-id="element-586">
                    Service packages are registered to a specific address and
                    cannot be transferred to another property
                  </li>
                  <li data-id="element-587">
                    Appliances must not exceed 10 years of age at the time of
                    package purchase
                  </li>
                </ul>
              </div>
            </div>
            <div className="mb-8" data-id="element-588">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-589">
                Service Exclusions
              </h2>
              <div className="bg-mwc-lightpink p-4 rounded-lg mb-4" data-id="element-590">
                <p className="text-gray-700 mb-2" data-id="element-591">
                  Our repair and maintenance services do not include:
                </p>
                <ul className="list-disc pl-6 text-gray-700" data-id="element-592">
                  <li data-id="element-593">
                    Damage caused by misuse, negligence, unauthorised repairs,
                    or deliberate damage
                  </li>
                  <li data-id="element-594">
                    Cosmetic damage that does not affect the appliance's
                    functionality
                  </li>
                  <li data-id="element-595">
                    Pre-existing faults or damage that occurred before service
                    package activation
                  </li>
                  <li data-id="element-596">
                    Commercial appliances or domestic appliances used in a
                    commercial setting
                  </li>
                  <li data-id="element-597">
                    Consumable items such as light bulbs, filters, batteries, or
                    detergent dispensers
                  </li>
                  <li data-id="element-598">
                    Routine maintenance tasks that are the user's responsibility
                    (as specified in the manufacturer's manual)
                  </li>
                  <li data-id="element-599">
                    Damage from natural disasters, floods, fire, or acts of God
                  </li>
                  <li data-id="element-600">
                    Appliances not used according to manufacturer guidelines
                  </li>
                </ul>
              </div>
            </div>
            <div className="mb-8" data-id="element-601">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-602">
                Engineer Visits and Service Delivery
              </h2>
              <div className="bg-mwc-lightpink p-4 rounded-lg mb-4" data-id="element-603">
                <p className="text-gray-700 mb-2" data-id="element-604">
                  When arranging an engineer visit:
                </p>
                <ul className="list-disc pl-6 text-gray-700" data-id="element-605">
                  <li data-id="element-606">
                    You must provide safe and unobstructed access to the
                    appliance
                  </li>
                  <li data-id="element-607">
                    An adult (18 years or older) must be present throughout the
                    entire visit
                  </li>
                  <li data-id="element-608">
                    You must follow any reasonable safety instructions from our
                    engineers
                  </li>
                  <li data-id="element-609">
                    We reserve the right to refuse service if conditions are
                    unsafe, unhygienic, or if the appliance is inaccessible
                  </li>
                  <li data-id="element-610">
                    Engineers will provide an estimated repair time and explain
                    the work required before proceeding
                  </li>
                  <li data-id="element-611">
                    You will be informed of any parts that need ordering and the
                    expected delivery timeframe
                  </li>
                </ul>
              </div>
            </div>
            <div className="mb-8" data-id="element-612">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-613">
                Payments and Pricing
              </h2>
              <div className="bg-mwc-lightpink p-4 rounded-lg mb-4" data-id="element-614">
                <p className="text-gray-700 mb-2" data-id="element-615">
                  For monthly payment packages:
                </p>
                <ul className="list-disc pl-6 text-gray-700" data-id="element-616">
                  <li data-id="element-617">
                    Payments are collected by Direct Debit on an agreed monthly
                    date
                  </li>
                  <li data-id="element-618">
                    Failure to maintain payments may result in suspension or
                    termination of service access
                  </li>
                  <li data-id="element-619">
                    We reserve the right to review and adjust package pricing
                    annually with 30 days' written notice
                  </li>
                  <li data-id="element-620">
                    Any price increases will be communicated clearly in advance
                  </li>
                </ul>
              </div>
            </div>
            <div className="mb-8" data-id="element-621">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-622">
                Cancellation and Termination
              </h2>
              <div className="bg-mwc-lightpink p-4 rounded-lg mb-4" data-id="element-623">
                <p className="text-gray-700 mb-2" data-id="element-624">
                  Please refer to our Cancellation Policy for details on how to
                  cancel your service package.
                </p>
                <p className="text-gray-700 mb-2" data-id="element-625">
                  We may terminate your service package access if:
                </p>
                <ul className="list-disc pl-6 text-gray-700" data-id="element-626">
                  <li data-id="element-627">
                    You provide false or misleading information about the
                    appliance condition
                  </li>
                  <li data-id="element-628">You fail to comply with these terms and conditions</li>
                  <li data-id="element-629">
                    You fail to make payments when due (for monthly payment
                    plans)
                  </li>
                  <li data-id="element-630">
                    You or members of your household abuse, threaten, or act
                    inappropriately toward our staff
                  </li>
                  <li data-id="element-631">
                    You make fraudulent service requests or misuse the service
                  </li>
                </ul>
              </div>
            </div>
            <div className="mb-8" data-id="element-632">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-633">
                Workmanship Assurance
              </h2>
              <div className="bg-mwc-lightpink p-4 rounded-lg mb-4" data-id="element-634">
                <p className="text-gray-700" data-id="element-635">
                  We stand behind the quality of our repair work. If the same
                  fault recurs within 90 days of our repair due to faulty
                  workmanship, we will return to address it at no additional
                  cost. This assurance does not apply to new faults, user error,
                  or damage caused after the repair.
                </p>
              </div>
            </div>
            <div className="mb-8" data-id="element-636">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-637">
                Limitation of Liability
              </h2>
              <div className="bg-mwc-lightpink p-4 rounded-lg mb-4" data-id="element-638">
                <p className="text-gray-700" data-id="element-639">
                  Our liability is limited to the cost of the repair or
                  replacement of the appliance under service. We are not liable
                  for any consequential losses, indirect damages, or losses
                  resulting from appliance failure, including but not limited to
                  food spoilage, loss of earnings, or inconvenience. Nothing in
                  these terms excludes our liability for death or personal
                  injury caused by our negligence.
                </p>
              </div>
            </div>
            <div className="mb-8" data-id="element-640">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-641">
                Changes to Terms
              </h2>
              <div className="bg-mwc-lightpink p-4 rounded-lg mb-4" data-id="element-642">
                <p className="text-gray-700" data-id="element-643">
                  We reserve the right to modify these terms and conditions to
                  reflect changes in our services, legal requirements, or
                  business practices. Any material changes will be communicated
                  to you in writing at least 30 days before they take effect.
                  Your continued use of our services after notification
                  constitutes acceptance of the updated terms.
                </p>
              </div>
            </div>
            <div className="mb-8" data-id="element-644">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-645">
                Complaints and Disputes
              </h2>
              <div className="bg-mwc-lightpink p-4 rounded-lg mb-4" data-id="element-646">
                <p className="text-gray-700" data-id="element-647">
                  If you have a complaint about our service, please contact our
                  customer service team at support@maplewood-care.com or call
                  0800 055 4969. We will investigate and respond to your
                  complaint within 14 business days. If you are not satisfied
                  with our response, you may escalate the matter through
                  alternative dispute resolution services.
                </p>
              </div>
            </div>
            <div data-id="element-648">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-649">
                Governing Law
              </h2>
              <div className="bg-mwc-lightpink p-4 rounded-lg" data-id="element-650">
                <p className="text-gray-700" data-id="element-651">
                  These terms and conditions are governed by and construed in
                  accordance with the laws of England and Wales. Any disputes
                  arising from these terms will be subject to the exclusive
                  jurisdiction of the courts of England and Wales.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default TermsConditions;